/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { RatingsWrapper } from '../styles'
import { ratings } from './data'
import { Header3 } from '../../../styles/Components'
import { createBugsnagErrorBoundary } from '../../../helpers'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay } from 'swiper/modules'

const QuotesBugsnagErrorBoundary = createBugsnagErrorBoundary('Quotes')

const RatingsSection = () => (
  <RatingsWrapper>
    <div className='swiper-container-container'>
      <QuotesBugsnagErrorBoundary>
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          navigation={{ nextEl: '.custom-next-button', prevEl: '.custom-prev-button' }}
          className='swiper-container'
        >
          {ratings.map((r, i) => (
            <SwiperSlide key={i}>
              <div className='rating'>
                <div className='star-container' role='img' aria-label='Rated 5 out of 5 stars'>
                  {new Array(5).fill('').map((_, i) => <img key={i} src='/home/star.svg' width="24" height="24" alt='' aria-hidden='true' />)}
                </div>
                <Header3 color='#fff' align='center' margin='0 0 16px 0'>
                  {r.quote}
                </Header3>
                <Header3 color='#fff' align='center'>
                  - {r.name}
                </Header3>
              </div>
            </SwiperSlide>
          ))}
          <button className='custom-prev-button' />
          <button className='custom-next-button' />
        </Swiper>
      </QuotesBugsnagErrorBoundary>
    </div>
  </RatingsWrapper>
)

export default RatingsSection
